
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `將其加入主畫面，以獲得更完整的體驗並方便存取。`,
's224cbcec014ef6b5': `點擊導覽列中的「分享」按鈕`,
's37a9e8aec5713460': `更多`,
's386eca8362ff6155': `若未看見「分享」圖示，請點擊「更多」`,
's4e1e10a6ca408245': `輕觸「加入主畫面」`,
's6196153c4b0c1ea0': `安裝`,
's633502f7cff4f847': `開啟瀏覽器選單`,
's681e399d63311fba': `顯示相簿`,
's7f0591f08e318eda': `在分享選單中點擊更多`,
's8114bd55cae5a22b': `點擊「加入 Dock」`,
's922329d6f6213590': `加入 Dock`,
's9af56bf005b49c74': `向下捲動至「加入主畫面」`,
'sa5ef80b4bb9b39f8': `收起`,
'sba52286c21552a4e': `在您的裝置上安裝，以獲得更完整的體驗並方便存取。`,
'sc16e00a7a8b2fde2': `返回`,
'scdaf4bbff76674c8': `加入主畫面`,
'se0e473adfda8066c': `在主瀏覽器中開啟`,
'se740f75b95a51807': `將其加入 Dock，以獲得更完整的體驗並方便隨時存取。`,
'sfea652f6580ff086': `此網站具備應用程式功能。`,
    };
  